import classNames from 'classnames';

import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import SingleTextLoader from 'organisms/Loaders/SingleTextLoader';
import { capitalizeFirstLetter } from 'util';

export default function ({ item, isLoading }) {
  const { width } = useWindowDimensions();
  const isMobile = width < 500;

  if (isLoading) return <SingleTextLoader />;

  const getIcon = () => {
    if (item.status === 'paid') return 'checkbox';
    if (item.status === 'declined') return 'unpaid';
    if (item.status === 'unpaid') return 'pending';
    return 'pending';
  };

  return (
    <div
      className={classNames(
        `payment-status payment-status--${item.status} radius-24 w-fit flex-row`
      )}
    >
      <Icon name={getIcon()} className="mr-5" />
      {!isMobile && <p>{capitalizeFirstLetter(item.status)}</p>}
    </div>
  );
}
